import React, { Component } from "react";
import TabCircles from "./TabCircles";

export default class Intro extends Component {
    constructor(props) {
        super(props);
        this.circleClick = this.circleClick.bind(this);
    }

    circleClick(tabId) {
        if (!this.props.waitingForSpeech) {
            this.props.setCurrentTab(tabId);
        }
    }

    render() {
        const p = this.props;

        return (
<div className="test-page-content-inner test-page-welcome">
    <TabList currentTabId={p.currentTabId} elems={p.content.elems[0].elems} circleClick={this.circleClick} />
</div>
        );
    }
}

function TabList(props) {
    const items = props.elems.filter(item => item.tabId === props.currentTabId).map((elem) =>
        <Tab key={elem.tabId} elems={elem.elems} />
    );
    return (
        <React.Fragment>
            {items}
            <TabCircles length={props.elems.length} currentTabId={props.currentTabId} circleClick={props.circleClick} />
        </React.Fragment>
    );
}

function Tab(props) {
    return (
        <div className="test-page-welcome-message">
            <div>
                {renderItems(props.elems)}
            </div>
        </div>
    );
}

function renderItems(elems) {
    return elems.map(function (elem, index) {
        return renderItem(elem, index);
    });
}

function renderItem(elem, index) {
    switch (elem.type) {
    case "h1":
        return <h1 key={index}>{elem.text}</h1>;
    case "h2":
        return <h2 key={index}>{elem.text}</h2>;
    case "p":
        return <p key={index}>{elem.text}</p>;
    default:
        return null;
    }
}
